import { Component, computed, inject, signal } from '@angular/core';

import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import {
  ConfirmDialogComponent,
  ConfirmDialogVariant,
  type DialogComponentI,
} from '@core/user-interface-legacy';

export interface ResetPasswordConfirmDialog {
  fullName: string;
}

@Component({
  selector: 'rt-reset-password-confirm-dialog',
  imports: [ConfirmDialogComponent, TranslatePipe],
  template: `
    @let fullNameValue = fullName();
    <rt-confirm-dialog
      [title]="
        'tlc.members.edit_member.actions.reset_password.confirm_dialog.title'
          | translate: { fullName: fullNameValue }
      "
      [message]="
        'tlc.members.edit_member.actions.reset_password.confirm_dialog.agree_text' | translate
      "
      [agreeLabel]="
        'tlc.members.edit_member.actions.reset_password.confirm_dialog.button_text' | translate
      "
      [cancelLabel]="'tlc.common.cancel' | translate"
      [variant]="ConfirmDialogVariant.Warning"
      [triggerUpdateOnInit]="true"
      [isCancelable]="true"
    />
  `,
})
export class ResetPasswordConfirmDialogComponent
  implements DialogComponentI<ResetPasswordConfirmDialog, boolean>
{
  private readonly i18n = inject(I18nService);
  public ConfirmDialogVariant: typeof ConfirmDialogVariant = ConfirmDialogVariant;
  public fullName = signal<string>('');
  protected message = computed(() =>
    this.i18n.translate('tlc.members.edit_member.actions.reset_password.confirm_dialog.title', {
      fullName: this.fullName(),
    }),
  );
  public setDialogData(data: ResetPasswordConfirmDialog): void {
    this.fullName.set(data.fullName);
  }
}
